<template>
  <div class="header">
    <div style="padding-left:20px">{{ this.title }}</div>
  </div>
</template>

<script>
export default {
  name: "mapheader",
  data() {
    return {
      title: "",
    };
  },
  methods: {},
  mounted() {
    this.title = window.headername;
  },
};
</script>


<style scoped>
.header {
  display: flex;
  background: rgba(100, 100, 100, 1);
  justify-content: flex-start;
  line-height: 60px;
  font-size: 25px;
  color: white;
  height: 60px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/mapheader.vue